/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import { modais } from './data';
import './Sandbox.css'; // Importando o arquivo CSS
import { getLastLinePreview, testAgent } from './utils';

export default function Sandbox() {
  const [processedData, setProcessedData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const results = await testAgent(modais);
        setProcessedData(results);
      } catch (err) {
        console.error('Erro ao processar dados:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) {
    return <div className="loading">🔄 Carregando análises...</div>;
  }

  return (
    <div className="sandbox-container">
      <h2>Sandbox Table</h2>
      <table className="sandbox-table">
        <thead>
          <tr className="table-header">
            <th className="table-cell">Input (preview)</th>
            <th className="table-cell">Class</th>
            <th className="table-cell">Scores</th>
            <th className="table-cell">Resultado</th>
          </tr>
        </thead>
        <tbody>
          {processedData.map((row, index) => (
            <tr key={index}>
              <td className="table-cell">
                {getLastLinePreview(modais[index].input)}
              </td>
              <td className="table-cell">{row.classification || '-'}</td>
              <td className="table-cell">{row.scores || '-'}</td>
              <td
                className="table-cell"
                dangerouslySetInnerHTML={{ __html: row.feedback || '-' }}
                aria-label={row.feedback || 'Nenhum feedback disponível'}
              />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
